<template>
  <div class="page-headline" :style="PageHeadlineStyle">
    <div class="page-headline-contents">
      <PageHeadlineTitle :title="title" />
    </div>
  </div>
</template>
<script>
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle.vue'
export default {
  components: { PageHeadlineTitle },
  props: {
    title: {
      type: String,
      required: true
    },
    textAlign: {
      type: String,
      required: false,
      default: 'center'
    }
  },
  computed: {
    PageHeadlineStyle() {
      return {
        'text-align': this.textAlign
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  background-color: $white;
  padding: 24px 16px;

  &-contents {
    margin: auto;
    max-width: $max-contents-width;
  }
}
</style>
